import { jazzHr as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  heading: 'Current Opportunities',
  subHeading:
    "We're always looking for great talent so if you don't see something that matches your expertise or there are no openings please reach out to email @address. com.",
};

export default fakeProps(schema, TestData);
